<script lang="ts">
  import { Link } from 'svelte-routing';
  import GoalEditor from './GoalEditor.svelte';
  import Ring from './Ring.svelte';
  import { goalLeft, goalScope, measureValue, periodNow, type Goal } from '../../utils/insights';
  import { sportOf } from '../../utils/sports';
  import { t } from '../../i18n/index.ts';

  // GoalsSection shows each goal as a ring with what is done, the target, and
  // what is left (spec 006 FR-064), and adds goals.
  let { goals, onchange }: { goals: Goal[]; onchange: () => void } = $props();
  let adding = $state(false);

  function icon(g: Goal): string {
    if (g.measure === 'steps') return 'la-shoe-prints';
    if (g.measure === 'active_minutes') return 'la-heartbeat';
    return g.sport ? `la-${sportOf(g.sport).icon}` : 'la-trophy';
  }
</script>

<section class="space-y-2" aria-labelledby="goals-heading">
  <div class="flex items-center justify-between">
    <h2 id="goals-heading" class="font-semibold">{t('activitiesGoals')}</h2>
    <button class="btn btn-secondary btn-sm" onclick={() => (adding = true)}><i aria-hidden="true" class="las la-plus mr-1"></i>{t('activitiesGoalsAdd')}</button>
  </div>
  {#if goals.length === 0}
    <p class="text-sm text-text-muted">{t('activitiesGoalsEmpty')}</p>
  {/if}
  <ul class="grid gap-2 sm:grid-cols-2">
    {#each goals as g (g.id)}
      <li>
        <Link to="/activities/goals/{g.id}" class="card flex items-center gap-3 p-3 hover:opacity-80">
          <Ring share={g.done / g.target} icon={icon(g)} />
          <span class="min-w-0">
            <span class="block font-medium">{periodNow(g.period)} · {goalLeft(g)}</span>
            <span class="block text-sm text-text-muted">{measureValue(g.measure, g.done)} / {measureValue(g.measure, g.target)}</span>
            <span class="block text-xs text-text-muted">{goalScope(g)}</span>
          </span>
        </Link>
      </li>
    {/each}
  </ul>
</section>

{#if adding}
  <GoalEditor onclose={() => (adding = false)} onsaved={() => { adding = false; onchange(); }} />
{/if}
